var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',{attrs:{"title":"Messagerie > Paramètres","description":`Configuration du canal ${_vm.cseLabel}, des délais de réponse et des messages automatiques.`}}),_c('ChatsSubmenu'),_c('PageContent',[_c('MessagingSettingsPanel',{attrs:{"show-global-templates":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }